import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import Layout from "../layout";
import { loadNews } from "../../redux/modules/news";
import { signOut } from "../../redux/modules/auth";

const News = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const news = useSelector((state) => state.news);
  const mobile = useSelector(state => state.mobile);
  useEffect(() => {
    document.title = "Новости | Личный кабинет Брокера THE FIVE";
    if (!news.loaded) {
      dispatch(
        loadNews({
          cmd: 'news',
          _debug_token: auth.token
        }));
    }
  }, []);

  if (news.error) {
    dispatch(signOut());
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout>
      {!mobile && <div className="title">Новости</div>}
      <div className="news">
        {news.response &&
          news.response.map((item, i) => (
            <Link to={`/news/${item.link}`} className={`news__item fadeIn delay${i + 1}00`} key={i}>
              <div className="news__image-wrapper">
                <div style={{ backgroundImage: `url('${item.imgPreview}')` }} className="news__image"/>
              </div>
              <div className="news__title">{item.name}</div>
              <div className="news__date">{item.date}</div>
            </Link>
          ))}
      </div>
    </Layout>
  );
};

export default News;
